import React from 'react';
import ListarPendienteIngreso from '../../../components/insumos/informes/ListarPendienteIngreso';
import { PageWrapper } from '../../../components/common';

const ListarPendienteIngresoPage: React.FC = () => {
  return (
    <PageWrapper>
      <ListarPendienteIngreso />
    </PageWrapper>
  );
};

export default ListarPendienteIngresoPage;
